import { Grid, Typography } from '@mui/material'
import { useAppSelector } from 'app/hooks'
import DialogConfirm from 'components/Dialogs/DialogConfirm'
import FloorMap from 'components/FloorMap'
import GameMap from 'components/Map/gameMap'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import axiosClient from 'utils/axiosClient'

export default function EventGame() {
  const { enqueueSnackbar } = useSnackbar()
  const { id } = useParams<{ id: string }>()
  const [joinConfirm, setJoinConfirm] = useState(false)
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const event = useAppSelector((s) =>
    s.Event.list.find((f) => f.id === Number(id))
  )
  if (!event) return null
  const handleSubmit = async () => {
    try {
      if (!event.checkpoints) return null
      const cpc = event.checkpoints.map((y) => [{ cpId: y.id, cleared: 0 }])
      setLoading(true)
      await axiosClient.post(`/api/events/${id}/join`, {
        data: JSON.stringify({ cpCheck: cpc }),
      })
      const msg = 'イベントを開始しました。'
      enqueueSnackbar(msg, {
        variant: 'success',
      })
      setTimeout(() => {
        navigate(`/event/${id}`)
      }, 100)
      setJoinConfirm(false)
    } catch (error) {
      const msg = 'エラーが発生しました。'
      enqueueSnackbar(msg, {
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <DialogConfirm
        open={joinConfirm}
        maxWidth="xs"
        loading={loading}
        handleSubmit={handleSubmit}
        title="確認"
        primaryButtonText="公開"
        primaryButtonColor="primary"
        handleClose={() => setJoinConfirm(false)}
      >
        <Typography>イベントに参加しますか？</Typography>
      </DialogConfirm>
      <Grid container mt={2}>
        {/* <Grid item xs={12}>
          <Typography
            variant="h5"
            fontWeight="bold"
            component="h2"
            sx={{ borderBottom: 2 }}
          >
            {event.name}
          </Typography>
        </Grid> */}
        <Grid item xs={12}>
          {event.useGPS
            ? event.checkpoints.length > 0 && (
                <GameMap positions={event.checkpoints} />
              )
            : event.floors.length > 0 && (
                <FloorMap floors={event.floors} positions={event.checkpoints} />
              )}
        </Grid>
      </Grid>
    </>
  )
}
